import type { NextPageWithAddons } from 'next';

import { NextSeo } from 'next-seo';

import { ForgotPasswordForm } from '@paid-ui/forms/forgot-password';
import { AuthLayout } from '@paid-ui/layouts/auth';

const ForgotPasswordPage: NextPageWithAddons = () => {
  return (
    <>
      <NextSeo title="Forgot password" />
      <ForgotPasswordForm />
    </>
  );
};

ForgotPasswordPage.layout = (page) => <AuthLayout>{page}</AuthLayout>;

export default ForgotPasswordPage;
